import { render } from "./TicketConversationView.vue?vue&type=template&id=1e982653&scoped=true"
import script from "./TicketConversationView.vue?vue&type=script&lang=js"
export * from "./TicketConversationView.vue?vue&type=script&lang=js"

import "./TicketConversationView.vue?vue&type=style&index=0&id=1e982653&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src1559117955/src/employer_portal_front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e982653"]])

export default __exports__